<div *ngIf="config" provide-parent-form>
	<bb-collapsible [title]="'VIDEO_SETTINGS' | translate" [startOpen]="publicationMode" togglePosition="before" theme="uui" [description]="'HELP.AUCTION_VIDEO_SETTINGS' | translate">

		<bb-form-element [form]="form" [label]="'MIN_DURATION' | translate" [helpMessage]="'HELP.MIN_DURATION' | translate"
		postLabel="seconds">
			<input type="number"
				[min]="0"
				[(ngModel)]="config['/mediaTypes/video/minduration']"
				[placeholder]="defaultValues['/mediaTypes/video/minduration']"
				name="video_minduration"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'MAX_DURATION' | translate" [helpMessage]="'HELP.MAX_DURATION' | translate"
			postLabel="seconds">
				<input type="number"
				[min]="config['/mediaTypes/video/minduration'] || 0"
				[(ngModel)]="config['/mediaTypes/video/maxduration']"
				[placeholder]="defaultValues['/mediaTypes/video/maxduration']"
				name="video_maxduration"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'MIN_BITRATE' | translate"
		[helpMessage]="'HELP.MIN_BITRATE' | translate"
		postLabel="kbps">
			<input type="number"
				[(ngModel)]="config['/mediaTypes/video/minbitrate']"
				[placeholder]="defaultValues['/mediaTypes/video/minbitrate']"
				name="video_minbitrate"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'MAX_BITRATE' | translate" 
		[helpMessage]="'HELP.MAX_BITRATE' | translate"
			postLabel="kbps">
			<input type="number"
				[(ngModel)]="config['/mediaTypes/video/maxbitrate']"
				[placeholder]="defaultValues['/mediaTypes/video/maxbitrate']"
				name="video_maxbitrate"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'MIME_TYPES' | translate"
		[helpMessage]="'HELP.MIME_TYPES' | translate">
			<bb-entity-selector
				name="video_mimetypes"
				[extendable]="true"
				[(ngModel)]="config['/mediaTypes/video/mimes']"
				[placeholder]="defaultValues['/mediaTypes/video/mimes']"
				[options]="mimeTypeOptions" [multi]="true"
			></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'WIDTH' | translate"
		[helpMessage]="'HELP.AUCTION_VIDEO_WIDTH' | translate"
		postLabel="px">
			<input type="number"
				[(ngModel)]="config['/mediaTypes/video/w']"
				[placeholder]="defaultValues['/mediaTypes/video/w']"
				name="video_width"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'HEIGHT' | translate" 
		[helpMessage]="'HELP.AUCTION_VIDEO_HEIGHT' | translate"
			postLabel="px">
			<input type="number"
				[(ngModel)]="config['/mediaTypes/video/h']"
				[placeholder]="defaultValues['/mediaTypes/video/h']"
				name="video_height"
			/>
		</bb-form-element>

	</bb-collapsible>
	<hr />
	
	<bb-collapsible [title]="'SLOT_SETTINGS' | translate" togglePosition="before" theme="uui" [description]="'HELP.AUCTION_SLOT_SETTINGS' | translate">

		<bb-form-element [form]="form" [label]="'AD_UNIT_POSITION' | translate"
		[helpMessage]="'HELP.AD_UNIT_POSITION' | translate">
			<bb-entity-selector [options]="adunitPositionOptions"
				[(ngModel)]="config['/mediaTypes/video/pos']"
				[placeholder]="defaultValues['/mediaTypes/video/pos'] + ' (' + ('DEFAULT' | translate) + ')'"
				name="video_pos"></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLACEMENT' | translate"
		[helpMessage]="'HELP.AUCTION_VIDEO_PLACEMENT' | translate">
			<bb-entity-selector
				[options]="placementOptions"
				[(ngModel)]="config['/mediaTypes/video/placement']"
				[placeholder]="defaultValues['/mediaTypes/video/placement'] + ' (' + ('DEFAULT' | translate) + ')'"
				name="video_placement"
			></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYBACK_METHOD' | translate"
		[helpMessage]="'HELP.PLAYBACK_METHOD' | translate">
			<bb-entity-selector
				[options]="playbackMethodOptions"
				[multi]="true"
				[(ngModel)]="config['/mediaTypes/video/playbackmethod']"
				[placeholder]="defaultValues['/mediaTypes/video/playbackmethod'] + ' (' + ('DEFAULT' | translate) + ')'"
				name="video_playbackmethod"
			></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYER_WIDTH' | translate" postLabel="px"
		[helpMessage]="'HELP.PLAYER_SIZE' | translate">
			<input type="number"
				[(ngModel)]="playerSizeWidth"
				[placeholder]="defaultValues['/mediaTypes/video/playerSize']?.[0] || ''"
				(ngModelChange)="onPlayerSizeChange()"
				name="video_playerSize0"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYER_HEIGHT' | translate" postLabel="px"
		[helpMessage]="'HELP.PLAYER_SIZE' | translate">
			<input type="number"
				[(ngModel)]="playerSizeHeight"
				[placeholder]="defaultValues['/mediaTypes/video/playerSize']?.[1] || ''"
				(ngModelChange)="onPlayerSizeChange()"
				name="video_playerSize1"
			/>
		</bb-form-element>
	</bb-collapsible>
	<hr />
	
	<bb-collapsible [title]="'PLAYER_SPECIFICATIONS' | translate" togglePosition="before" theme="uui" [description]="'HELP.AUCTION_PLAYER_SPECIFICATIONS' | translate">
		<bb-form-element [form]="form" [label]="'API_FRAMEWORKS' | translate"
		[helpMessage]="'HELP.API_FRAMEWORKS' | translate">
			<bb-entity-selector [(ngModel)]="config['/mediaTypes/video/api']"
				[placeholder]="defaultValues['/mediaTypes/video/api']"
				[options]="apiFrameworkOptions" [multi]="true"
				name="video_api"></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'BID_RESPONSE_PROTOCOL' | translate"
		[helpMessage]="'HELP.BID_RESPONSE_PROTOCOL' | translate">
			<bb-entity-selector
				[(ngModel)]="config['/mediaTypes/video/protocols']"
				[placeholder]="defaultValues['/mediaTypes/video/protocols']"
				[options]="bidResponseProtocolOptions" [multi]="true"
				name="video_protocols"></bb-entity-selector>
		</bb-form-element>
		
		<bb-form-element [form]="form" [label]="'DELIVERY' | translate"
		[helpMessage]="'HELP.AUCTION_DELIVERY' | translate">
			<bb-entity-selector
				[(ngModel)]="config['/mediaTypes/video/delivery']"
				[placeholder]="defaultValues['/mediaTypes/video/delivery']"
				[options]="deliveryOptions" [multi]="true"
				name="video_delivery" ></bb-entity-selector>
		</bb-form-element>

	</bb-collapsible>
	<hr />

	
	<bb-collapsible [title]="'MISCELLANEOUS' | translate" togglePosition="before" theme="uui" [description]="'HELP.AUCTION_MISCELLANEOUS' | translate">
		<bb-form-element [form]="form" [label]="'BIDDER_TIMEOUT' | translate"
		[helpMessage]="'HELP.AUCTION_BIDDER_TIMEOUT' | translate"
			postLabel="ms">
			<input type="number"
				min="100"
				[(ngModel)]="config['/bidderTimeout']"
				[defaultValue]="defaultValues['/bidderTimeout']"
				name="bidder_timeout"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'DEVICE_ACCESS' | translate"
		[helpMessage]="'HELP.AUCTION_DEVICE_ACCESS' | translate">
			<bb-check [(ngModel)]="config['/deviceAccess']"
				[defaultValue]="defaultValues['/deviceAccess']"
				name="device_access"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'SKIP_FIRST_PARTY_DATA_ENRICHMENTS' | translate"
		[helpMessage]="'HELP.SKIP_FIRST_PARTY_DATA_ENRICHMENTS' | translate">
			<bb-check [(ngModel)]="config['/firstPartyData/skipEnrichments']"
				[defaultValue]="defaultValues['/firstPartyData/skipEnrichments']"
			name="skip_enrichments"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'ENABLE_GPT_PRE_AUCTION_MODULE' | translate">
			<bb-check [(ngModel)]="config['/gptPreAuction/enabled']"
				[defaultValue]="defaultValues['/gptPreAuction/enabled']"
				name="gpt_pre_auction"></bb-check>
		</bb-form-element>

	</bb-collapsible>
</div>
